import { Inject, Injectable, Optional } from '@angular/core';

import { OddsAcceptanceMode } from '@bpos';
import { SyncUserSettingsService } from '@frontend/sports/user/feature';

import IOddsSettingsService from '../../../integration/services/odds-settings.service';
import { ODDS_SETTINGS_SERVICE } from '../../../integration/sports-injection-services';
import { ISettingsState, defaultSettingsState } from '../state';

@Injectable()
export default class SettingsStateStorageService {
    constructor(
        private userSettings: SyncUserSettingsService,
        @Inject(ODDS_SETTINGS_SERVICE) @Optional() private oddsSettingsService?: IOddsSettingsService,
    ) {}

    toSavedState(state: ISettingsState): ISettingsState {
        return state;
    }

    fromSavedState(state: ISettingsState | undefined): ISettingsState {
        // When loading from storage ( on page load ) we check if oddsSettingsService is available:
        //   Yes: It is betstation and we get OddsAcceptance from the service ( e.g. local storage )
        //   No: It is digital and we get the value from userService which is always updated when settings are changed.
        const oddsAcceptance =
            (this.oddsSettingsService?.getOddsAcceptance() as OddsAcceptanceMode) ||
            (this.userSettings.bettingSettings.oddsAcceptanceMode as unknown as OddsAcceptanceMode) ||
            OddsAcceptanceMode.No;
        const notifications = state?.notifications || defaultSettingsState.notifications;

        return {
            oddsAcceptance,
            notifications,
        };
    }
}
